import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import EditProductCategory from './../edit/EditProductCategory';
import Dialog from './DialogBase';

class DialogEditProductCategory extends React.Component {

  constructor (props) {
    super(props);
    this._isMounted = false; // isMounted React pattern to avoid memory leaks
    this.state = {
      title: '',
    }
  }

  componentDidMount () {
    this._isMounted = true;
    const { category } = this.props;
    if (category !== null && category !== undefined) {
      this._isMounted && this.setState({
        title: "Modifier une catégorie",
      });
    } else {
      this._isMounted && this.setState({
        title: "Nouvelle catégorie",
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render () {
    const { classes, open, onClose, fullScreen, keepMounted, ...others } = this.props;
    return (
      <Dialog
        keepMounted={keepMounted}
        fullScreen={fullScreen}
        open={open}
        onClose={onClose}
        title={this.state.title}
      >
        <EditProductCategory
          fixedCtrl={true}
          {...others}
        />
      </Dialog>
    )
  }
}

const styles = theme => ({});

DialogEditProductCategory.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(DialogEditProductCategory);
